export default __webpack_public_path__ + "static/SupportLargeFont-DO1-60c846b7c83660b288250615a6506001.png";